import styled from 'styled-components';

const BoxGoogleAuth = styled.div`
  background: #1b73e8;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  max-height: 54px;
  border-radius: 8px;
`;

export { BoxGoogleAuth };
